export abstract class DragDropItem {
  protected __rank: string;
  abstract rank: string;
  protected __rankNumber?: number;
  abstract rankNumber: number;
}
